<template>
    <div class="gc-add-help-wrap">
        <van-nav-bar :border="false" 
            title="创建"
            left-arrow
            @click-left="$router.back()"
        />
        <div class="help-box-wrap">
            <div class="item">
                <span>日期</span>
                <div class="time">{{today}}</div>
            </div>
        </div>
        <div class="help-box-wrap">
            <span>内容</span>
            <textarea class="textarea" placeholder="请输入经营早报内容" v-model="areaValue"></textarea>
        </div>
        <div class="submit-btn" @click="WebSetManagementTool">提  交</div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                areaValue: '',
                today: ''
            }
        },
        mounted() {
            this.today = this.dateToString(new Date())
            this.WebGetManagementToolDetail();
        },
        methods: {
            WebSetManagementTool(){
                if(!this.areaValue){
                    this.$toast('请输入内容')
                    return
                }               
                
                this.$dialog.confirm({
                    title:'提示',
                    message: '提交后不可更改，是否确认？',
                    confirmButtonColor: '#D32F2F'
                }).then(()=>{                   
                    let data = {
                        id: this.$route.params.id||'',
                        usersysno: localStorage.getItem('UserSysno'),
                        ContentContent: this.areaValue
                    }
                    this.$baseajax.sliceRequest(this.$base.baseapi+'/WebSetManagementTool',data,res=>{
                        console.log(res);                   
                        if(res.ResponseCode==1){
                            this.$toast('操作成功')
                            this.$router.go(-1);
                        }else{
                            this.$toast(res.ResponseMessage)
                        }
                    },err=>{})
                }).catch(()=>{})                
                
            },
            // 详情
            WebGetManagementToolDetail(){
                let data = { 
                    bsysno: this.$route.params.id,                  
                    UserSysno: localStorage.getItem('UserSysno')
                }
                this.$baseajax.normalJsonp(this.$base.baseapi+'/WebGetManagementToolDetail',data,res=>{
                    console.log(res); 
                    res = res.WebGetManagementToolDetailResult               
                    if(res.ResponseCode==1){
                        if(res.Item){                            
                            this.areaValue = res.Item.ContentContent
                        }
                    }
                },err=>{})
            },
            dateToString(e){
                let year = e.getFullYear()
                let month = e.getMonth()+1
                month = month < 10 ? '0' + month : month
                let day = e.getDate()
                day = day < 10 ? '0' + day : day
                return year+'-'+month+'-'+day;
            },
        },
    }
</script>

<style lang="less" scoped>
.gc-add-help-wrap{ 
    padding-bottom: 1.6rem;   
    .help-box-wrap{
        margin: .28rem .28rem 0;
        padding: .38rem .48rem;
        background-color: #ffffff;
        box-shadow: 0rem 0.01rem 0.17rem 0rem rgba(41, 22, 110, 0.17);
        border-radius: 0.27rem;
        font-size: 0.33rem;
	    color: #888888;
        .item{
            display: flex;
            justify-content: space-between;
        }
        span{
            font-size: 0.4rem;
	        color: #333333;
        }
        .textarea{
            display: block;
            width: 100%;
            margin-top: 0.5rem;
            font-size: 0.33rem;
            line-height: 0.53rem;
            height: 5.3rem;
            color: #666;
            resize: vertical;
        }
    }
    .submit-btn{
        position: fixed;
        bottom: 0.28rem;
        left: 0.6rem;
        width: 8.8rem;
        height: 1.04rem;
        line-height: 1.04rem;
        text-align: center;
        background-color: #D32F2F;
        box-shadow: 0rem 0.01rem 0.09rem 0rem  rgba(26, 26, 26, 0.29);
        border-radius: 0.2rem;
        font-size: 0.47rem;
	    color: #ffffff;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/add/AddHelp.vue